import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";

const Cart = {
  extends: Model,
  mixins: [
    Persistable
  ]
};

export default defineReactiveModel(Cart);
